export interface NewReserveRank {
  id: number
  revision: number
}

export interface ReserveRankUpdateRequest {
  bibliographyId: number
  reserves: NewReserveRank[]
}

export function ReserveRankUpdateRequestToJSON(
  value: ReserveRankUpdateRequest
): any {
  return {
    bibliography_id: value.bibliographyId,
    reserves: value.reserves.map(item => {
      return {
        id: item.id,
        revision: item.revision
      }
    })
  }
}
